import { List } from 'immutable';
import { createSelector } from 'reselect';
import { getTeamsMember } from '../teams-members';

export function getTeamsMembersList(state) {
  return state.teams_members_lists;
}

export function getTeamMembersListById(state, teamsMembersListId) {
  return getTeamsMembersList(state).get(teamsMembersListId);
}

//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentTeamMembersList = createSelector(
  getTeamsMembersList,
  teams_members_lists => teams_members_lists.get(teams_members_lists.get('currentTeamMembersListId'))
);

export const getTeamsMembersForCurrentTeamMembersList = createSelector(
  getCurrentTeamMembersList,
  getTeamsMember,
  (team_member_lists, team_members) => {
    if(!team_members.size === 0 || !team_member_lists) {
      return new List();
    }

    return team_member_lists.itemsId.map( id => team_members.get(`${id}`) )
  }
);